export default "https://cdn-static.gokick.com/assets/4e3548e0bbc963e39203d4ae4090204efad0894d/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";